<template>
  <div class="user-view">
    <el-popover placement="top-start" width="200" trigger="hover" popper-class="no-padding-popover">
      <div class="detail-view">
        <img src="@/assets/images/avatar_bg.png" class="user-avatar mlr14">
        <div class="text-view">
          <span class="shop-name single">{{ $store.state.user.userInfoAfterLogin.sid }}</span>
          <span class="username single">{{ $store.state.user.userInfoAfterLogin.fullname }}</span>
        </div>
      </div>
      <div class="logout-view">
        <div v-if="getLanguage ==='zh'" v-outFocus class="lang-btn" @click="setLanguage('en')">
          <svg-icon icon-class="English" />Switch to English
        </div>
        <div v-if="getLanguage ==='en'" v-outFocus class="lang-btn" @click="setLanguage('zh')">
          <svg-icon icon-class="chinese" />切换为中文
        </div>
      </div>
      <div class="logout-view">
        <span class="logout-wrapper" style="color:#616366;" @click="toChangePwd">
          <img class="logout-icon" src="@/assets/images/Home/changePwd.png">
          {{this.$t('home.changePasswd')}}
        </span>
        <div class="border" />
      </div>
      <div class="logout-view">
        <span class="logout-wrapper" @click="logout">
          <img class="logout-icon" src="@/assets/images/Home/logout.png">
          {{ this.$t('home.Sign_out') }}
        </span>
      </div>

      <!-- 引用部分 -->
      <div slot="reference" class="outer-user-view">
        <img src="@/assets/images/avatar_bg.png" class="user-avatar center">
        <div class="shop-name-outer single">{{ $store.state.user.userInfoAfterLogin.sid }}</div>
      </div>
    </el-popover>

    <el-dialog title="修改密码" :visible.sync="visible">
      <el-form :label-position="labelPosition" label-width="70px">
        <el-form-item label="账号">
          <el-input class="w_200" v-model="form.account" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="原密码">

          <el-input class="w_200" type="password" v-model="form.oldPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input class="w_200" type="password" v-model="form.newPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input class="w_200" type="password" v-model="form.confirmPassword" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleOk">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { setLangCookie } from '@/services/utils/modules/authBj'
import { getUrlErpChangePasswd } from '@/services/microFeUtil/utils/pageUrl'
import { addPageTagAndNavigate } from '@/services/microFeUtil/pageTagUtils'
import { resolveVueRouterAndOpenNewTab } from '@/services/utils/modules/routerWrapper'

export default {
  data() {
    return {
      visible: false,
      labelPosition: 'right',
      form: {
        account: '',
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    }
  },
  computed: {
    getLanguage() {
      return this.$i18n.locale
    }
  },
  created() {
  },
  methods: {
    async setLanguage(type) {
      // if (type === 'zh') {
      //   this.$i18n.locale = 'zh'
      //   Cookies.set('language', 'zh')// 保存一次
      //   setLangCookie('zh')
      //   await this.switchLanguage(1)
      //   const result = /hw/.test(window.location.host)
      //   this.$store.dispatch('menu/getMenuList', result)
      // } else {
      //   this.$i18n.locale = 'en'
      //   Cookies.set('language', 'en')
      //   await this.switchLanguage(2)
      //   const result = /hw/.test(window.location.host)
      //   this.$store.dispatch('menu/getMenuList', result)
      // }

      setLangCookie(type)
      this.$i18n.locale = type

      // 服务端更新语言
      const { code } = await this.$request(this.$api.common.switchLanguage, {
        // 1=中文 2=英文
        language: type === 'zh' ? 1 : 2
      })

      if (code === 200) {
        // 目的是更新菜单title的中英文
        location.reload()
      }
      // 刷新页面
      // location.reload()
    },
    toChangePwd() {
      // const baseAppUrl = getUrlErpChangePasswd()
      // addPageTagAndNavigate(baseAppUrl)
      // resolveVueRouterAndOpenNewTab

      this.$router.push({
        name: 'passwd',
        query: {
          type: 'inner'
        }
      })
    },
    async logout() {
      this.$store.dispatch('user/logout', { type: 'manual' }).then((xFrom) => {
        if (xFrom === 1) {
          // location.href = `${this.$utils.getErpDomain()}/login?redirect=${encodeURIComponent(location.href)}&type=bi`
          location.href = `${this.$utils.getErpDomain()}/login`
        } else {
          // this.$router.push(`/user/login?redirect=${this.$route.fullPath}`)
          this.$router.push('/user/login')
        }
      })
    },
    showModal() {
      this.visible = true
      this.form = {
        account: '',
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    },
    async handleOk() {
      if (this.form.account === '') return this.$message.error('账号不能为空')
      if (this.form.oldPassword === '') return this.$message.error('愿密码不能为空')
      if (this.form.newPassword === '') return this.$message.error('新密码不能为空')
      if (this.form.confirmPassword === '') return this.$message.error('确认密码不能为空')
      if (this.form.newPassword === this.form.oldPassword) return this.$message.error('新旧密码不能相同')
      if (this.form.newPassword !== this.form.confirmPassword) return this.$message.error('密码和确认密码不一致，请重新输入')
      const params = {
        account: this.form.account, // 账号
        password: this.form.oldPassword, // 旧密码
        newPassword: this.form.newPassword // 新密码
      }
      const { code, msg } = await this.$request(this.$api.login.updatePwd, params)
      if (code === 200) {
        // this.formConfig.shopId.options = this.initShopMap(data.list)
        this.$message.success(msg)
      } else {
        this.$message.error(msg)
      }
    },
    goUserCenter() {
      window.open(`${this.$utils.getErpDomain()}/personal-center`)
    },
    async switchLanguage(distLang) {
      const { code } = await this.$request(this.$api.common.switchLanguage, {
        // 1=中文 2=英文
        language: this.$store.state.user.language === 1 ? 2 : 1
      })
      if (code === 200) {
        location.reload()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-view {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.user-btn-box{
  .user-btn {
    padding: 10px;
    text-align: center;
    cursor: pointer;
  }
}
.w_200{
  width: 200px;
}
.detail-view {
  width: 100%;
  height: 84px;
  background-image: url('~@/assets/images/user_info_view.png');
  background-size: 100% 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  .text-view {
    height: 40px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
.logout-view {
  position: relative;
  width: 100%;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  color: #E3464C;
  // border-top: 1px solid #e6ebf5;
  .logout-wrapper {
    // margin-left: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    // width: 68px;
    justify-content: space-between;
    cursor: pointer;
    .logout-icon {
      width: 16px;
      height: 16px;
    }
  }
}
.outer-user-view {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
}
.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
.shop-name {
  font-size: 14px;
  font-weight: 500;
  color: #322D34;
  width: 120px;
  text-align: left;
}
.shop-name-outer {
  font-size: 12px;
  font-weight: 400;
  width: 49px;
  height: 17px;
  font-family: PingFangSC-Medium,PingFang SC;
  font-weight: 500;
  color: #969CAC;
  line-height: 17px;
  margin-bottom: 21px;
  text-align: center;
}
.username {
  font-size: 12px;
  font-weight: 400;
  color: #969CAC;
  width: 120px;
  text-align: left;
}
.center {
  margin: 0 auto;
}
.mlr14 {
  margin-left: 14px;
  margin-right: 14px;
}
.single {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.lang-btn {
    width: calc(100% - 32px);
    height: 100%;
    line-height: 49px;
    text-align: center;
    border-radius:1px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #616366;
    cursor: pointer;
    opacity: 1;
    &:hover{
     opacity: 0.7;
    }
    .svg-icon{
        font-size:16px;
        vertical-align: -0.2em;
    }
}
.border {
  position: absolute;
  width: calc(100% - 32px);
  bottom: 0;
  height: 1px;
  border-bottom: 1px solid #f0f0f0;
}
</style>
